export default {
  common: {
    colon: '：',
    cancel: '取消',
    confirm: '确认',
    back: '返回',
    noBooking: '未找到预约信息',
    placeholderNote: '画面待补充（等待设计图）'
  },
  views: {
    trainList: {
      vehicleInfo: '车辆信息',
      ticketName: '新干线车票',
      travelDate: '参加日期：',
      route: '出发和到达：',
      ticketCount: '预约数量：',
      adult: '成人票',
      child: '儿童票',
      trainType: '车型',
      seatClass: '座位类型：',
      preOrderNote:
        '*预约超过一个月订单时，出票将延至乘车日的前一个月，届时可在首页查看结果',
      selectStation: '选择车站',
      from: '出发',
      to: '到达',
      selectTrain: '选择车次',
      select: '选择',
      book: '预订',
      seatAvailable: '余票充足',
      seatLimited: '余票不足',
      soldOut: '票已售罄',
      notOnSale: '暂未开售',
      durationFormat: '{{hours}}时{{minutes}}分',
      noTrains: '该时间段暂无车次'
    },
    seat: {
      title: '请选择座位',
      ticketCount: '预约数量',
      adult: '成人票',
      preference: '位置偏好',
      window: '优先靠窗',
      aisle: '优先靠过道',
      adjacent: '优先靠座',
      next: '下一步'
    },
    confirm: {
      trainConfirm: '车次确认',
      ticketName: '新干线车票',
      route: '出发和到达：',
      travelDate: '参加日期：',
      ticketCount: '预约数量：',
      trainType: '车型：',
      seatClass: '座位类型：',
      preference: '位置偏好：',
      confirmSelect: '确认选择'
    },
    submitted: {
      title: '预约已提交',
      thanks: '感谢您的预订，请返回首页查看出票结果',
      thanksSub: '*乘车前一个月开始出票，请耐心等待',
      ticketName: '新干线车票',
      route: '出发和到达：',
      travelDate: '参加日期：',
      ticketCount: '预约数量：',
      trainType: '车型：',
      seatClass: '座位类型：',
      preference: '位置偏好：',
      backHome: '返回首页',
      noticeTitle: '注意事项',
      notice1:
        '每日23:30~05:30（日本时间）系统维护期间暂停出票，维护结束后自动出票，结果可在首页查看。',
      notice2:
        '出票失败时，首页票券将显示「余票不足」，请点击底部「预订车票」按钮重新操作。'
    }
  }
};
